/**
 * A short list, not the ~600 IANA zones: a 600-entry select is not a control anyone
 * successfully uses, and every customer is in this region. Widen it when one is not.
 * Ho Chi Minh leads because it is the stored default.
 */
export const REPORTING_TIMEZONES = [
  'Asia/Ho_Chi_Minh',
  'Asia/Bangkok',
  'Asia/Phnom_Penh',
  'Asia/Vientiane',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Asia/Jakarta',
  'Asia/Manila',
  'Asia/Hong_Kong',
  'Asia/Taipei',
  'Asia/Seoul',
  'Asia/Tokyo',
] as const;

/** Hours in a 31-day month — the ceiling a per-month figure cannot exceed. Mirrors the
 * server's MAX_PAYROLL_HOURS_PER_MONTH (apps/server/src/restaurants/restaurantReporting.constants.ts);
 * kept as a separate literal here rather than imported, since the portal has no import path
 * into server source. */
export const MAX_PAYROLL_HOURS_PER_MONTH = 744;

/**
 * "Ho Chi Minh (GMT+7)". The offset comes from Intl rather than a stored table so it stays
 * correct across a DST change in any zone later added to the list. A runtime without
 * `shortOffset` support degrades to the city alone rather than throwing.
 */
export function timezoneLabel(zone: string): string {
  const city = zone.split('/')[1]?.replace(/_/g, ' ') ?? zone;
  try {
    const offset = new Intl.DateTimeFormat('en', { timeZone: zone, timeZoneName: 'shortOffset' })
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value;
    return offset ? `${city} (${offset})` : city;
  } catch {
    return city;
  }
}
